import { CommonData } from '../common_schema'

export const rocksdbRWRaftEngineData: CommonData[] = [
  {
    name: 'Write Duration(p99)',
    mean: 'P99_raft_engine_write_duration:total.values.mean',
    std: 'P99_raft_engine_write_duration:total.values.std',
    location: 'TiKV-Details --> Raft Engine --> Write Duration'
  },
  {
    name: 'WAL Duration Breakdown (999%) for sync',
    mean: 'P999_raft_engine_sync_log_duration:total.values.mean',
    std: 'P999_raft_engine_sync_log_duration:total.values.std',
    location: 'TiKV-Details --> Raft Engine --> WAL Duration Breakdown (999%)'
  }
]
